export const getWeekDays = (dictionaries?: string[]) => {
  return dictionaries
    ? [...dictionaries]
    : ["Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag"];
};
